angular
	.module('servicepro.analysis.summary')
	.controller('SummaryController', [
		'$log',
		'$scope',
		'$rootScope',
		'$filter',
		'$resource',
		'$timeout',
		'gettextCatalog',
		'apiURLs',
		'$http',
		'$compile',
		'lineChartOptions',

		function SummaryControllerFactory($log, $scope, $rootScope, $filter, $resource, $timeout, gettextCatalog, apiURLs, $http, $compile, lineChartOptions) {
            $log.debug('SummaryControllerFactory OK');

			var dateEndDt = moment(),
				dateStartDt = moment(dateEndDt).subtract(1, 'weeks'),
				linesChart;

			$scope.state = {
				init: true,
				loading: true,
				filters: { // API filters
					daterange: {
						start: dateStartDt.format('YYYY-MM-DD'), // 'YYYY-MM-DD'
						end: dateEndDt.format('YYYY-MM-DD') // 'YYYY-MM-DD'
					}
				}
			};

			$scope.drawLinesChart = function(requestsData) {
				$("#summary-total-requests").html(requestsData.totals.requests);
                $("#summary-total-orders-open").html(requestsData.totals.orders);
                $("#summary-total-orders-not-attended").html(requestsData.totals.notAttended);
                $("#summary-total-results").html(requestsData.totals.results);

                var colorLines = {
                    requests: '#f17e5f',
                    orders: '#6ec563',
                    results: '#1ba4d3'
                };

                var labelsDates = requestsData.per_dates.labels;
                var labels = [];
                var months = [];
                labelsDates.forEach(function(part, index) {
                    labels[index] = new Date(part).getDate();
                    months[index] = new Date(part).getMonthName();
                });
                months = Array.from(new Set(months)).join(' / ');

                var dataSet = [];
                for(var item in requestsData.per_dates.counts) {
                    if (item !== 'notAttended') {
                        var data = {
                            borderColor: colorLines[item],
                            pointBorderColor: colorLines[item],
                            data: requestsData.per_dates.counts[item]
                        };
                        dataSet.push(data);
                    }
                }

                if (linesChart instanceof Chart) {
                    linesChart.destroy();
                }
                linesChart = new Chart($("#summary-line-chart"), {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: dataSet,
                    },
                    options: lineChartOptions(months)
                });
			};

			// API opts based on state
			$scope.getApiOptions = function(overrides) {
				var options = {};
				// API filters
				if ($scope.state.filters.daterange) {
					options.date_from = $scope.state.filters.daterange.start;
					options.date_to = $scope.state.filters.daterange.end;
				}
				// Apply overrides
				angular.extend(options, overrides);
				return options;
			};

			// Draw charts
			$scope.draw = function() {
                $resource(apiURLs.analysis.summary).query(
			        $scope.getApiOptions(),
					function(requestsData) {
						$scope.drawLinesChart(requestsData);
					}, function(requestsData) {
						$log.error("Summary Data. FAILED");
					}
				);
			};

			// Watch for filters
			// Daterange: fetch from API
			$scope.$watchCollection('state.filters.daterange', function(nv, ov) {
				if (!$scope.state.init) {
					$scope.draw();
				}
			});

			// Init
			$scope.init = function() {
				$scope.state.init = false;
			};
			// Init
			$scope.init();
        }
    ]);